

















































































































import {Component, Provide, Vue} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import EmailConfig from '@/models/emailconfig';
import CButton from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import validator from '@/utils/validator';
import validationMsgs from '@/constants/validation';
import {redirectTime} from '@/constants/constants';
import {VueEditor} from 'vue2-editor';
import {API} from '@/services/api/api';
import {dynamicValues} from '@/services/email-config.ts';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {CButton, FormInput, VueEditor},
})
export default class EditEmailConfig extends Vue {
  emailConfig: EmailConfig = {
    isActive: true,
    senderName: '',
    subjectLine: '',
    configurationFor: '',
    body: '',
    dynamicValue: '',
  };

  //loader and helper variables
  isScreenLoading = false;
  saving = false;
  showSuccessToast: any;
  showErrorToast: any;

  //validation variables
  nameValidationMsg = null;
  configForValidationMsg = null;
  subjectLineValidationMsg = null;
  bodyValidationMsg = null;
  dynamicValueValidationMsg = null;

  configForList = [
    {
      id: 'Inspection',
      name: 'Inspection',
    },
    {
      id: 'Surveyor',
      name: 'Surveyor',
    },
  ];
  dynamicValueList = dynamicValues;

  //validation functions
  validateSenderName() {
    const senderName = this.emailConfig.senderName;
    if (validator.isNullOrEmpty(senderName)) {
      this.nameValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.nameValidationMsg = null;
      return true;
    }
  }
  validateConfigFor() {
    const config = this.emailConfig.configurationFor;
    if (validator.isNullOrEmpty(config)) {
      this.configForValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.configForValidationMsg = null;
      return true;
    }
  }
  validateSubjectLine() {
    const subject = this.emailConfig.subjectLine;
    if (validator.isNullOrEmpty(subject)) {
      this.subjectLineValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.subjectLineValidationMsg = null;
      return true;
    }
  }
  validateDyanmicValue() {
    const value = this.emailConfig.dynamicValue;
    if (validator.isNullOrEmpty(value)) {
      this.dynamicValueValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.dynamicValueValidationMsg = null;
      return true;
    }
  }
  validateBody() {
    const body = this.emailConfig.body;
    if (validator.isNullOrEmpty(body)) {
      this.bodyValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.bodyValidationMsg = null;
      return true;
    }
  }
  validateAll() {
    return (
      this.validateSenderName() &&
      this.validateConfigFor() &&
      this.validateSubjectLine() &&
      this.validateDyanmicValue() &&
      this.validateBody()
    );
  }
  async onSubmitClick() {
    if (!this.validateAll()) return false;
    this.saving = true;
    try {
      const response = await API.createEmailConfig(this.emailConfig);
      this.saving = false;
      if (response.data) {
        this.showSuccessToast({msg: 'Record created'});
        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.saving = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHandler() {
    this.$router.go(-1);
  }

  onAddClick() {
    if (!this.emailConfig.dynamicValue) return;
    this.emailConfig.body += `#${this.emailConfig.dynamicValue}#`;
  }
}
